import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderSlot as _renderSlot, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, mergeProps as _mergeProps, resolveDynamicComponent as _resolveDynamicComponent } from "vue"

const _hoisted_1 = { key: 1 }


import {
  ref,
  onMounted,
  reactive,
  defineExpose,
  nextTick,
  computed,
  getCurrentInstance,
  useAttrs,
  ComponentInternalInstance,
  onActivated
} from 'vue'
import { QuestionCircleOutlined } from '@ant-design/icons-vue'
import CustomTable from '@/components/CustomTable/index.vue'
import type { ColumnItem } from '../index'
import { AxiosPagination } from '@/typings/common'
import cosTableProps from '../cosTableType'
import { cloneDeep } from 'lodash-es'
import { useDebounceFn } from '@vueuse/core'
import Mask from '../../Mask'
import { useI18n } from 'vue-i18n'
import { useInteractionStore } from '@/stores/interaction'
const __default__ = { name: 'CosTable' }

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: cosTableProps(),
  emits: ['update:search', 'search', 'mask'],
  setup(__props, { expose: __expose, emit: __emit }) {

const { slots } = getCurrentInstance() as ComponentInternalInstance
const attrs = useAttrs()
const { t } = useI18n()
const props = __props
const page = reactive<{
  current: number
  pageSize: number
  total: number
  showSizeChanger: boolean
}>({
  current: 1,
  pageSize: 10,
  total: 0,
  showSizeChanger: true
})
let initSearch: any
const tableDataSource = ref<{ [key: string]: any }[]>([])
const searchLoading = ref<boolean>(false)
const searchExtra = ref<any>({})
const tableLoading = ref<boolean>(false)
const dicDatas = ref<{
  [key: string]: any[]
}>({})
const selectedRowKeys = ref([])
const shareInfo = useInteractionStore()
const emit = __emit
// 设置列
const columnsComputed = computed(() => {
  return props.columns.map((item: ColumnItem) => {
    // 处理数据字典
    // 处理多语言宽度
    const eumns = {
      'en-US': 'en',
      'zh-CN': 'zh'
    }
    // 自动处理宽度
    let width = item.width
    if (!width) {
      const n = (item.title as string)?.length * 10
      width = n < 100 ? 100 : n
    }
    if (item.langWidth) {
      width = item.langWidth[eumns[shareInfo.language]]
    }
    if (item.dicData) {
      let key = item.dataIndex
      if (item.dicData) {
        if (typeof item.dataIndex === 'string') {
          key = item.dataIndex
          dicDatas.value[`$${key}`] = item.dicData
        } else if (Array.isArray(item.dataIndex)) {
          key = item.dataIndex.join('.')
          dicDatas.value[`$${key}`] = item.dicData
        }
      }
      return {
        ...item,
        width,
        dataIndex: '$' + key
      }
    }
    return {
      ...item,
      width
    }
  })
})
// 设置列数据
const dataComputed = computed(() => {
  let result = cloneDeep(tableDataSource.value)
  if (props.dataSource) {
    result = props.dataSource
  }
  for (const key in dicDatas.value) {
    result.forEach((item) => {
      const keyList: string[] = key.replace('$', '').split('.')
      const objVal = keyList.reduce((objRow: any, currentKey: string) => objRow && objRow[currentKey], item)
      const resultTxt: any[] = []
      let resultobjVal: any[] = objVal
      if (!Array.isArray(objVal)) {
        resultobjVal = [objVal]
      }
      if (Array.isArray(resultobjVal)) {
        // 过滤掉null和undefined
        const new_resultobjVal = resultobjVal.filter((v) => v != null)
        new_resultobjVal.forEach((ov: any) => {
          const obj = dicDatas.value[key].find(
            (v) => (v.value !== undefined && v.value === ov) || (v.id !== undefined && v.id === ov)
          )
          const eumns = {
            'en-US': 'enName',
            'zh-CN': 'cnName'
          }
          // 普通数字字典
          if (obj && obj.label) {
            if (obj.lang) {
              resultTxt.push(t(obj.lang))
            } else {
              resultTxt.push(obj.label)
            }
          }
          // 业务参数---id
          if (obj && obj.id) {
            if (obj[eumns[shareInfo.language]]) {
              resultTxt.push(obj[eumns[shareInfo.language]])
            }
          }
          if (!obj && ov !== -9) {
            resultTxt.push(ov)
          }
        })
        item[key] = resultTxt.join('、')
      }
    })
  }
  return result
})
// 点击搜索，重置按钮
const search = (type: 'search' | 'reset' | undefined) => {
  page.current = 1
  if (type === 'search') {
    // 清除无效的搜索条件
    const result = cloneDeep(props.search)
    for (const key in result) {
      // -9 代表数字类型的空值，需要过滤掉
      if (result[key] === null || result[key] === '' || result[key] === -9) {
        result[key] = undefined
      }
    }
    Object.assign(props.search, result)
    // emit('update:search', )
  }
  if (type === 'reset') {
    // 重置搜索
    const result = {
      ...cloneDeep(initSearch)
    }
    for (const key in props.search) {
      if (result[key] === undefined) {
        result[key] = undefined
      }
    }
    Object.assign(props.search, result)
    // emit('update:search' )
  }
  emit('search', type)
  nextTick(() => {
    fetch()
  })
}
const onSelectChange = (rowKeys: any, rows: any) => {
  selectedRowKeys.value = rowKeys
  props.rowSelection?.onChange(rowKeys, rows)
}
const getCheckboxProps = (record: any) => {
  if (props.rowSelection?.getCheckboxProps) {
    return props.rowSelection?.getCheckboxProps(record)
  }
}
// 去掉前后空格递归
const trimValue = (search: any) => {
  for (const key in search) {
    if (search[key]) {
      if (typeof search[key] === 'string') {
        search[key] = search[key].replace(/(^\s*)|(\s*$)/g, '')
      } else if (typeof search[key] === 'object') {
        trimValue(search[key])
      }
    }
  }
}
// 请求列表数据
const fetch = () => {
  if (attrs.onFetch && typeof attrs.onFetch === 'function') {
    // 判断是否有fetch
    tableLoading.value = true
    const { search } = props
    // 去掉搜索前后空格
    trimValue(search)
    if (!initSearch) {
      initSearch = cloneDeep(search)
    }
    attrs.onFetch(
      {
        pageNumber: page.current,
        pageSize: page.pageSize,
        ...search,
        ...searchExtra.value
      },
      (res: AxiosPagination<any>) => {
        searchLoading.value = false
        tableLoading.value = false
        if (res && res.data) {
          if (res.data.items) {
            tableDataSource.value = res.data.items
            page.current = res.data.pageNumber || 0
            page.total = res.data.totalCount || 0
          } else if (Array.isArray(res.data)) {
            tableDataSource.value = res.data
          }
          // 直接清空多选选择数据,如果后期需要回写，再改动
          onSelectChange([], [])
        }
      }
    )
  }
  // 超时
  setTimeout(() => {
    tableLoading.value = false
  }, 5000)
}
const handleChangePage = (pageNum: number, pageSize: number) => {
  if (!pageNum || pageSize !== page.pageSize) {
    page.current = 1
    page.pageSize = pageSize
  }
  fetch()
}
// 处理表格排序
const handChangeTable = (pagination: any, filters: any, sorter: any, extra: any) => {
  // 排序
  if (extra) {
    const extraParam: any = {}
    if (sorter && sorter.order) {
      extraParam.sortingFields = [
        {
          column: typeof sorter.field === 'string' ? sorter.field : sorter.field[sorter.field.length - 1],
          asc: sorter.order === 'ascend'
        }
      ]
    } else {
      extraParam.sortingFields = undefined
    }
    searchExtra.value = extraParam
    fetch()
  }
}
// 处理掩码(显示掩码内容)
const showMask = (row: any, index: number) => {
  if (!tableDataSource.value[index].$maskContact) {
    emit('mask', row, (res: AxiosPagination<any>) => {
      tableDataSource.value[index].$maskContact = {
        hideMask: true,
        ...res
      }
    })
  } else {
    tableDataSource.value[index].$maskContact.hideMask = true
  }
}
// 处理掩码(隐藏掩码内容)
const hideMask = (row: any, index: number) => {
  tableDataSource.value[index].$maskContact = {
    ...tableDataSource.value[index].$maskContact,
    hideMask: false
  }
}
const notifyItem = (index: number, row: any) => {
  tableDataSource.value[index] = row
}
// 删除列表数据-刷新列表
const delFetch = (ids?: any[] | string | number, rowKey?: string) => {
  if (ids) {
    //  rowKey  传参 或者 attrs.rowKey 二选一
    const key: any = rowKey || attrs.rowKey
    let fils: any = []
    if (Array.isArray(ids)) {
      fils = [...ids]
    } else if (typeof ids === 'string' || typeof ids === 'number') {
      fils.push(ids)
    }
    if (key) {
      const other = tableDataSource.value?.filter((item: any) => !fils.includes(item[key]))
      if (!other || !other.length) {
        page.current--
      }
    }
  } else {
    // 没有参数，默认单个删除（比对数据长度，当只有一条时，page.current-1）
    if (tableDataSource.value?.length === 1) {
      page.current--
    }
  }
  if (page.current < 1) {
    page.current = 1
  }
  fetch()
}
__expose({
  fetch,
  delFetch,
  search,
  notifyItem
})
const fetchFn = useDebounceFn(() => {
  fetch()
}, 200)
onMounted(() => {
  fetchFn()
})
onActivated(() => {
  fetchFn()
})

return (_ctx: any,_cache: any) => {
  const _component_dc_layout_search = _resolveComponent("dc-layout-search")!
  const _component_dc_layout_button_group = _resolveComponent("dc-layout-button-group")!
  const _component_a_tooltip = _resolveComponent("a-tooltip")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_pagination = _resolveComponent("a-pagination")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_unref(slots)?.search)
      ? (_openBlock(), _createBlock(_component_dc_layout_search, {
          key: 0,
          isUp: false,
          loading: tableLoading.value,
          onSearch: _cache[0] || (_cache[0] = ($event: any) => (search('search'))),
          onReset: _cache[1] || (_cache[1] = ($event: any) => (search('reset')))
        }, {
          default: _withCtx(() => [
            _renderSlot(_ctx.$slots, "search")
          ]),
          _: 3
        }, 8, ["loading"]))
      : _createCommentVNode("", true),
    (_unref(slots)?.button)
      ? (_openBlock(), _createBlock(_component_dc_layout_button_group, { key: 1 }, {
          default: _withCtx(() => [
            _renderSlot(_ctx.$slots, "button")
          ]),
          _: 3
        }))
      : _createCommentVNode("", true),
    _createVNode(CustomTable, _mergeProps(_ctx.$attrs, {
      loading: tableLoading.value || _ctx.loading,
      columns: columnsComputed.value,
      "data-source": dataComputed.value,
      dynamicColumnSetting: _ctx.dynamicColumnSetting,
      "row-selection": 
      _ctx.rowSelection
        ? { selectedRowKeys: selectedRowKeys.value, onChange: onSelectChange, getCheckboxProps: getCheckboxProps }
        : undefined
    ,
      onChange: handChangeTable
    }), {
      headerCell: _withCtx(({ title, column }) => [
        (column.headerQuestion)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _createTextVNode(_toDisplayString(title) + " ", 1),
              _createVNode(_component_a_tooltip, { placement: "top" }, {
                title: _withCtx(() => [
                  _createElementVNode("span", null, _toDisplayString(column.headerQuestion), 1)
                ]),
                default: _withCtx(() => [
                  _createVNode(_unref(QuestionCircleOutlined), { style: { fontSize: '14px', fontWeight: 'normal' } })
                ]),
                _: 2
              }, 1024)
            ], 64))
          : _createCommentVNode("", true),
        _renderSlot(_ctx.$slots, "headerCell", {
          title: title,
          column: column
        })
      ]),
      bodyCell: _withCtx(({ text, record, index, column }) => [
        (column.cosType === 'mask')
          ? (_openBlock(), _createBlock(_unref(Mask), {
              key: 0,
              text: text,
              onShow: ($event: any) => (showMask(record, index)),
              onHide: ($event: any) => (hideMask(record, index)),
              dataIndex: column.dataIndex,
              maskContact: record.$maskContact
            }, null, 8, ["text", "onShow", "onHide", "dataIndex", "maskContact"]))
          : _createCommentVNode("", true),
        (column.cosType === 'money')
          ? (_openBlock(), _createElementBlock("p", _hoisted_1, _toDisplayString(text?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',') || '--'), 1))
          : (column.filterNoVal)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                _createTextVNode(_toDisplayString(text === '0' || !text ? '--' : text), 1)
              ], 64))
            : _createCommentVNode("", true),
        _renderSlot(_ctx.$slots, "bodyCell", {
          text: text,
          record: record,
          index: index,
          column: column
        })
      ]),
      _: 3
    }, 16, ["loading", "columns", "data-source", "dynamicColumnSetting", "row-selection"]),
    (props.needPage)
      ? (_openBlock(), _createBlock(_component_a_pagination, {
          key: 2,
          current: page.current,
          "onUpdate:current": _cache[2] || (_cache[2] = ($event: any) => ((page.current) = $event)),
          total: page.total,
          showTotal: (totalCount) => `${_unref(t)('common.totalText')} ${totalCount} ${_unref(t)('common.totalNum')}：`,
          showSizeChanger: "",
          onChange: handleChangePage
        }, {
          itemRender: _withCtx(({ type, originalElement }) => [
            (type === 'prev')
              ? (_openBlock(), _createBlock(_component_a_button, { key: 0 }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_unref(t)('common.prev')), 1)
                  ]),
                  _: 1
                }))
              : (type === 'next')
                ? (_openBlock(), _createBlock(_component_a_button, { key: 1 }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_unref(t)('common.next')), 1)
                    ]),
                    _: 1
                  }))
                : (_openBlock(), _createBlock(_resolveDynamicComponent(originalElement), { key: 2 }))
          ]),
          _: 1
        }, 8, ["current", "total", "showTotal"]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})